import { useContext } from 'react';
import { AuthenticationContext } from 'contexts/AuthenticationContext';

export const useAuthentication = () => {
  const authenticationContext = useContext(AuthenticationContext);

  return authenticationContext;
};
